import React from "react";

const Utilities = () => {
  return (
    <div className="utilities">
      <div>Utility 1</div>
      <div>Utility 2</div>
      <div>Utility 3</div>
    </div>
  );
};

export default Utilities;
